import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthContext';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const FeatureContext = createContext({});

export const useFeatures = () => useContext(FeatureContext);

export const FeatureProvider = ({ children }) => {
  const { token } = useAuth();
  const [features, setFeatures] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!token) { setLoading(false); return; }
    fetch(`${API_URL}/api/features`, {
      headers: { 'Authorization': `Bearer ${token}` }
    })
      .then(r => r.ok ? r.json() : {})
      .then(data => setFeatures(data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [token]);

  const isEnabled = (key) => features[key] !== false;

  return (
    <FeatureContext.Provider value={{ features, loading, isEnabled }}>
      {children}
    </FeatureContext.Provider>
  );
};
